'use strict';

var _ = require('lodash');
var toastr = require('toastr');
var RecommendationEntryController = function RecommendationEntryController($scope, recommendationEntryService, recommendationEntryDataService, exportToCSVService, FaresOptimizerConstants, userSecureService, faresOptimizerSharedFbcService, webFareCurveDataService, tacticalFareDefinitionService, momentService, filingFilterService, cityToPosMapper, faresOptimizerDataTransformerService, featureToggleService, faresOptimizerAnalysisDataService) {
  $scope.getData = function () {
    return _.get($scope, 'entry.rowGroups');
  };
  $scope.getRawData = function () {
    return _.get($scope, 'screenState.rawData');
  };
  function getSelectedItem() {
    return _.filter($scope.getData(), 'selected');
  }
  function getApproverLevel() {
    return _.get($scope, 'entry.approverType');
  }
  function isOnlyApprover() {
    return _.get($scope, 'entry.isOnlyApprover');
  }
  function getTodaysDate() {
    var momentConfig = momentService.ruleTypeToConfig('utc2date');
    return _.isUndefined(momentConfig) ? '' : momentService.systemNow(momentConfig).startOf('day');
  }
  function getSearchCriteriaForGrid(status) {
    var dataGrid = $scope.getData();
    return {
      carrier: dataGrid[0].carrier,
      market: dataGrid[0].market,
      cabin: dataGrid[0].cabin,
      category: dataGrid[0].category,
      status: status
    };
  }
  function getSelectedPendingOrNewItems() {
    var pendingRows = _.filter($scope.getRawData(), getSearchCriteriaForGrid(FaresOptimizerConstants.PENDING)) || [];
    var newRows = _.filter($scope.getRawData(), getSearchCriteriaForGrid(FaresOptimizerConstants.NEW)) || [];
    var allRows = _.concat(pendingRows, newRows);
    var userSelectedRows = getSelectedItem();
    $scope.userNotSelectedRows = _.difference(allRows, userSelectedRows);
    if (userSelectedRows.length === 0) {
      userSelectedRows = allRows;
    }
    $scope.allRowsSelected = userSelectedRows.length === allRows.length;
    return userSelectedRows;
  }
  function getPendingOrNewItems(ladderData) {
    var pendingRows = _.filter(ladderData, {
      status: FaresOptimizerConstants.PENDING
    }) || [];
    var newRows = _.filter(ladderData, {
      status: FaresOptimizerConstants.NEW
    }) || [];
    return _.concat(pendingRows, newRows);
  }
  function getEligibleLaddersForApproval(ladderData) {
    var eligibleLadders = getPendingOrNewItems(ladderData);
    var eligibleLaddersWithValidFootnotes = getLaddersWithValidFootnotes(eligibleLadders);
    return getLaddersWithValidProducts(eligibleLaddersWithValidFootnotes);
  }
  function identifyLaddersOfReverseCarrierMarketCabin(ladders) {
    var cabins = _.chain(ladders).map('cabin').uniq().value();
    return _.filter($scope.screenState.rawData, function (ladder) {
      return ladder.carrier === ladders[0].carrier && ladder.origin === ladders[0].destination && ladder.destination === ladders[0].origin && ladder.category === ladders[0].category && cabins.includes(ladder.cabin);
    }) || [];
  }
  function getEligibleLaddersForReverseCarrierMarketCabin(ladders) {
    var reverseMarketLadders = identifyLaddersOfReverseCarrierMarketCabin(ladders);
    return getEligibleLaddersForApproval(reverseMarketLadders);
  }
  function getUniqueReverseMarketCabins(reverseMarketLadderDetailsForApproval) {
    return _.chain(reverseMarketLadderDetailsForApproval).map('carrierMarketCabin').uniq().value().join(', ');
  }
  function getItemsForRejection() {
    var pendingRows = _.filter($scope.getData(), {
      status: FaresOptimizerConstants.PENDING
    }) || [];
    var newRows = _.filter($scope.getData(), {
      status: FaresOptimizerConstants.NEW
    }) || [];
    var futureApprovedRows = _.filter($scope.getData(), function (row) {
      return recommendationEntryService.ladderWithApprovalDateInFuture(row);
    }) || [];
    var allRows = _.concat(pendingRows, newRows, futureApprovedRows);
    var userSelectedRows = _.filter(allRows, 'selected');
    if (userSelectedRows.length === 0) {
      userSelectedRows = allRows;
    }
    return userSelectedRows;
  }
  function getSelectedFiledOrValidatedItems() {
    var data = $scope.getData();
    var allRows = [];
    _.forEach(data, function (entry) {
      if ((entry.status === FaresOptimizerConstants.FILED || entry.status === FaresOptimizerConstants.VALIDATED) && !recommendationEntryService.isCurrentRecommendationInProcess(data, entry)) {
        allRows.push(entry);
      }
    });
    var userSelectedRows = _.filter(allRows, 'selected');
    if (userSelectedRows.length === 0) {
      userSelectedRows = allRows;
    }
    return userSelectedRows;
  }
  function getLadderIds(data) {
    return _.map(data, $scope.screenState.recommendMode !== 'ADAPTIVE' ? 'fareRecommendationRecordKey' : 'fareLadderRecordKey');
  }
  function getLadderIdsForApprovedLadderUpdation(data) {
    var ladderIds = $scope.screenState.recommendMode !== 'ADAPTIVE' ? _.union([data.fareRecommendationRecordKey], data.allSharedFbcLadderIds) : [data.fareLadderRecordKey];
    return _.chain(ladderIds).filter(filterLaddersInApprovedStateWithFutureEffectiveDate).value();
  }
  function filterLaddersInApprovedStateWithFutureEffectiveDate(ladderId) {
    var ladder = $scope.screenState.recommendMode !== 'ADAPTIVE' ? _.find($scope.screenState.rawData, {
      'fareRecommendationRecordKey': ladderId
    }) : _.find($scope.screenState.rawData, {
      'fareLadderRecordKey': ladderId
    });
    return ladder.status === 'Approved' && ladder.recommendationEffectiveDate.startOf('day').isAfter(getTodaysDate());
  }
  function getLadderDetailsForApprovedStatusDetails(data, rawData) {
    var ladderIds = getLadderIdsForApprovedLadderUpdation(data);
    return _.chain(ladderIds).map(function (ladderId) {
      var ladder = $scope.screenState.recommendMode !== 'ADAPTIVE' ? _.find(rawData, {
        'fareRecommendationRecordKey': ladderId
      }) : _.find(rawData, {
        'fareLadderRecordKey': ladderId
      });
      return {
        ladderId: ladderId,
        fbc: ladder.fbc.replace(ladder.fbc.charAt(0), '*'),
        hasSharedFbc: ladder.allSharedEntryLevelFbcList.length >= 1
      };
    }).value();
  }
  $scope.setLaddersForApprovalUpdation = function (ladder) {
    $scope.laddersForApprovalUpdation = getLadderDetailsForApprovedStatusDetails(ladder, $scope.screenState.rawData);
  };
  $scope.approveButton = FaresOptimizerConstants.APPROVE_ALL;
  $scope.rejectButton = FaresOptimizerConstants.REJECT_ALL;
  $scope.undoButton = FaresOptimizerConstants.UNDO_ALL;
  $scope.validSelectedLadderCount = 0;
  $scope.approveTooltip = 'Only New and Pending Recommendations can be Approved';
  $scope.rejectTooltip = 'Only New and Pending Recommendations can be Rejected';
  if ($scope.screenState.recommendMode === 'STRUCTURAL') {
    $scope.undoTooltip = 'Only Validated Recommendations can be Undone';
    $scope.undoToastrError = 'Only Validated Recommendations can be Undone';
  } else if ($scope.screenState.recommendMode === 'TACTICAL') {
    $scope.undoTooltip = 'Only Filed and Validated Recommendations can be Undone';
    $scope.undoToastrError = 'Only Filed and Validated Recommendations can be Undone';
  }
  $scope.approveToastrError = 'Only New and Pending Recommendations can be Approved';
  $scope.rejectToastrError = 'Only New and Pending Recommendations can be Rejected';
  $scope.noFailureAuditLogMsg = 'No Failure Audit Log found for last reopt';
  $scope.initController = function () {
    $scope.groupedDataCollapsed = true;
    $scope.collapseGroupsButtonLabel = $scope.getCollapseButtonLabel();
    $scope.isExpanded = true;
    $scope.detailsDisabled = false;
    $scope.createRejectModal = false;
    $scope.createApproveModal = false;
    $scope.createAuditLogModal = false;
    $scope.createWarningModal = false;
    $scope.statusDetails = {
      isOnlyApprover: isOnlyApprover(),
      approverLevel: getApproverLevel()
    };
    $scope.gridSettings.settings.maxApprovalDateRetriever = {
      getApprovalDate: recommendationEntryService.getMinimumOfTravelAndReservationDates
    };
  };
  $scope.toggleExpanded = function () {
    $scope.isExpanded = !$scope.isExpanded;
  };
  $scope.disableApproveRejectButtons = function () {
    return getApproverLevel() === undefined || !userSecureService.hasAuthorization('fares-optimizer-analysis', 'write');
  };
  $scope.hideUndoButton = function () {
    return 'ADAPTIVE' === $scope.screenState.recommendMode && !isLadderOfOTF();
  };
  $scope.hideRejectButton = function () {
    return 'ADAPTIVE' === $scope.screenState.recommendMode && !isLadderOfOTF();
  };
  $scope.toggleGroupCollapse = function () {
    $scope.groupedDataCollapsed = !$scope.groupedDataCollapsed;
    $scope.collapseGroupsButtonLabel = $scope.getCollapseButtonLabel();
    _.forEach($scope.getData(), function (group) {
      group.isCollapsed = $scope.groupedDataCollapsed;
    });
    $scope.$broadcast('simple-grid:force-refresh');
  };
  $scope.updateCollapseButtonState = function () {
    var collapsedCount = _.filter($scope.getData(), 'isCollapsed').length;
    if (collapsedCount === 0) {
      $scope.groupedDataCollapsed = false;
    }
    if (collapsedCount === $scope.getData().length) {
      $scope.groupedDataCollapsed = true;
    }
    $scope.collapseGroupsButtonLabel = $scope.getCollapseButtonLabel();
  };
  function updateDetailsLinkState() {
    var selectedItems = getSelectedItem();
    if (selectedItems) {
      $scope.selectedItem = selectedItems[0];
    } else {
      $scope.selectedItem = $scope.getData()[0];
    }
  }
  function updateButtons() {
    updateButtonsForApproveAll();
    var selectedItems = getSelectedItem();
    var validFootnoteLadders = getLaddersWithValidFootnotes(selectedItems);
    var validProductLadders = getLaddersWithValidProducts(validFootnoteLadders);
    var approvalCount = recommendationEntryService.getApprovalCount(validProductLadders, getApproverLevel(), isOnlyApprover());
    var rejectionCount = recommendationEntryService.getRejectionCount(selectedItems, getApproverLevel(), isOnlyApprover());
    var undoCount = recommendationEntryService.getUndoCount(selectedItems, getApproverLevel(), $scope.getRawData());
    if (getApproverLevel() === undefined || selectedItems.length === 0) {
      $scope.approveButton = FaresOptimizerConstants.APPROVE_ALL;
      $scope.rejectButton = FaresOptimizerConstants.REJECT_ALL;
      $scope.undoButton = FaresOptimizerConstants.UNDO_ALL;
      if ('ADAPTIVE' === $scope.screenState.recommendMode && featureToggleService.isEnabled('ADAPTIVE_APPROVE_ALL_LADDERS')) {
        $scope.disableApproveButton = false;
      }
    } else {
      handleApproveButtonCount(approvalCount);
      $scope.rejectButton = 'Reject (' + rejectionCount + ')';
      $scope.undoButton = 'Undo (' + undoCount + ')';
    }
  }
  function handleApproveButtonCount(approvalCount) {
    if ('ADAPTIVE' === $scope.screenState.recommendMode && featureToggleService.isEnabled('ADAPTIVE_APPROVE_ALL_LADDERS') && !isLadderOfOTF()) {
      $scope.approveButton = FaresOptimizerConstants.APPROVE_ALL;
      $scope.disableApproveButton = approvalCount !== $scope.validSelectedLadderCount;
    } else {
      $scope.approveButton = 'Approve (' + approvalCount + ')';
    }
  }
  function updateButtonsForApproveAll() {
    var allItems = $scope.getData();
    var validFootnoteLadders = getLaddersWithValidFootnotes(allItems);
    var validProductLadders = getLaddersWithValidProducts(validFootnoteLadders);
    $scope.validSelectedLadderCount = recommendationEntryService.getApprovalCount(validProductLadders, getApproverLevel(), isOnlyApprover());
  }
  function updateToolTipsAndToastrMessages() {
    if (getApproverLevel() === 'intermediate') {
      $scope.approveTooltip = 'Only New Recommendations can be Approved';
      $scope.rejectTooltip = 'Only New Recommendations can be Rejected';
      $scope.approveToastrError = 'Only New Recommendations can be Approved';
      $scope.rejectToastrError = 'Only New Recommendations can be Rejected';
    } else if (!isOnlyApprover() && getApproverLevel() === 'final') {
      $scope.approveTooltip = 'Only Pending Recommendations can be Approved';
      $scope.rejectTooltip = 'Only Pending Recommendations can be Rejected';
      $scope.approveToastrError = 'Only Pending Recommendations can be Approved';
      $scope.rejectToastrError = 'Only Pending Recommendations can be Rejected';
    } else if (getApproverLevel() === undefined) {
      $scope.approveTooltip = '';
      $scope.rejectTooltip = '';
      $scope.undoTooltip = '';
    }
  }
  $scope.selectionCallBack = function () {
    updateDetailsLinkState();
    updateButtons();
    updateToolTipsAndToastrMessages();
  };
  $scope.getCollapseButtonLabel = function () {
    return $scope.groupedDataCollapsed ? 'Expand all' : 'Collapse all';
  };
  $scope.initController();
  $scope.showDetailsOverlay = function () {
    if ($scope.selectedItem === undefined) {
      $scope.selectedItem = $scope.getData()[0];
    }
    var context = buildRecommendationDetailsContext();
    $scope.screenState.recommendationDetailsMode = 'hostView';
    $scope.screenState.recommendationDetailsPanel.ladderGroupChartDataList = [];
    $scope.screenState.recommendationDetailsPanel.chartDataAvailable = false;
    $scope.screenState.recommendationDetailsPanel.visible = true;
    $scope.screenState.recommendationDetailsPanel.contextData = context;
    if ($scope.screenState.recommendMode !== 'ADAPTIVE') {
      getWebFareCurveData(context);
      getTacticalFareDefinitionData(context);
    }
  };
  $scope.showFailureAuditLogModal = function () {
    var ladderItem = $scope.getData()[0];
    var failureAuditLogQuery = {
      carrier: ladderItem.carrier,
      origin: ladderItem.origin,
      destination: ladderItem.destination,
      cabin: ladderItem.cabin,
      pos: ladderItem.pos,
      category: ladderItem.category
    };
    faresOptimizerAnalysisDataService.getFailureAuditLogData(failureAuditLogQuery).then(function (data) {
      var count = data === null || data === void 0 ? void 0 : data.length;
      if (count === 0) {
        toastr.info($scope.noFailureAuditLogMsg);
      } else {
        $scope.auditLogModalData = {
          count: count,
          auditLogData: data
        };
        $scope.showAuditLogModal = true;
        $scope.createAuditLogModal = true;
      }
    });
  };
  function buildRecommendationDetailsContext() {
    var context = _.cloneDeep($scope.selectedItem);
    context.entryLabels = $scope.entry.detailLabels;
    context.fareLaddersInGroup = $scope.entry.rowGroups;
    return context;
  }
  function getWebFareCurveData(context) {
    var cachedWebFares = _.find($scope.screenState.webFaresByKey, {
      key: buildWebFareKey(context)
    });
    if (cachedWebFares) {
      $scope.screenState.recommendationDetailsPanel.webFaresByCarrierAndFareType = cachedWebFares.webFaresByCarrierAndFareType;
      return;
    }
    var searchCriteria = buildWebFareCurveSearchCriteria(context);
    webFareCurveDataService.getWebFaresData(searchCriteria).then(function (data) {
      var webFares = _.flatten(data);
      var webFaresByCarrierAndFareType = groupWebFaresByCarrierAndFareType(webFares);
      var webFaresByKey = {
        key: buildWebFareKey(context),
        webFaresByCarrierAndFareType: webFaresByCarrierAndFareType
      };
      $scope.screenState.webFaresByKey.push(webFaresByKey);
      $scope.screenState.recommendationDetailsPanel.webFaresByCarrierAndFareType = webFaresByCarrierAndFareType;
    });
  }
  function groupWebFaresByCarrierAndFareType(webFares) {
    var webFaresByCarrierAndFareType = [];
    var webFaresByCarrier = _.groupBy(webFares, 'carrier');
    _.forEach(_.keys(webFaresByCarrier), function (carrier) {
      var webFaresByFareType = _.groupBy(webFaresByCarrier[carrier], 'tripType');
      _.forEach(_.keys(webFaresByFareType), function (fareType) {
        webFaresByCarrierAndFareType.push({
          carrier: carrier,
          fareTypeIndicator: fareType,
          webFares: webFaresByFareType[fareType]
        });
      });
    });
    return webFaresByCarrierAndFareType;
  }
  function buildWebFareCurveSearchCriteria(context) {
    return ['hostCarrier == ' + context.carrier, 'origin == ' + context.origin, 'destination == ' + context.destination, 'cabin == ' + context.cabin, 'category == ' + context.category].join(';');
  }
  function buildWebFareKey(context) {
    return [context.carrier, context.origin, context.destination, context.cabin, context.category].join('-');
  }
  function getTacticalFareDefinitionData(context) {
    var attributes = {
      carrier: context.carrier,
      origin: context.origin,
      destination: context.destination,
      cabin: context.cabin,
      originCountry: context.pos,
      destinationCountry: cityToPosMapper.getCountry(context.destination)
    };
    var cachedTacticalFareDefinition = _.find($scope.screenState.tacticalFareDefinitionDataByAttributes, {
      attributes: buildTacticalFareDefinitionKey(attributes)
    });
    if (cachedTacticalFareDefinition) {
      $scope.screenState.recommendationDetailsPanel.tacticalFareDefinitionData = cachedTacticalFareDefinition.tacticalFareDefinitionProperties;
      return;
    }
    tacticalFareDefinitionService.getTacticalFareDefinitionData(attributes).then(function (properties) {
      var tacticalFareDefinitionDataByAttributes = {
        attributes: buildTacticalFareDefinitionKey(attributes),
        tacticalFareDefinitionProperties: properties
      };
      $scope.screenState.tacticalFareDefinitionDataByAttributes.push(tacticalFareDefinitionDataByAttributes);
      $scope.screenState.recommendationDetailsPanel.tacticalFareDefinitionData = properties;
    });
  }
  function buildTacticalFareDefinitionKey(attributes) {
    return [attributes.carrier, attributes.origin, attributes.destination, attributes.originCountry, attributes.destinationCountry, attributes.cabin].join('-');
  }
  function getData(selectedItems) {
    return selectedItems.length === 0 ? $scope.getData() : selectedItems;
  }
  function isLadderOfOTF() {
    return _.some($scope.screenState.rawData, {
      type: FaresOptimizerConstants.LADDER_TYPE.OFFER_TRANSLATION
    });
  }
  $scope.undoCallback = function () {
    $scope.screenState.reorderGroupOptions = false;
    var recordKeyList = {
      authorizationNotes: $scope.stateChangeModal.authorizationNotes,
      fareRecommendationUndoKeyList: $scope.stateChangeModal.fareRecommendationUndoKeyList
    };
    if ($scope.screenState.recommendMode === 'ADAPTIVE') {
      recordKeyList = Object.assign(recordKeyList, {
        offerBasedLadderUndoKeyList: $scope.stateChangeModal.fareLadderUndoKeyList
      });
      delete recordKeyList.fareRecommendationUndoKeyList;
    }
    recommendationEntryDataService.updateRecommendationStatus('undo', recordKeyList, $scope.screenState.displayedRawData, $scope.screenState.rawData, undefined, $scope.screenState.marketRawDataChunks, $scope.screenState.pager.currentPage, $scope.screenState.recommendMode);
  };
  $scope.undoAll = function () {
    if (!$scope.disableApproveRejectButtons()) {
      var selectedItems = getSelectedItem();
      var count = recommendationEntryService.getUndoCount(getData(selectedItems), getApproverLevel(), $scope.getRawData());
      var ladderDetailsForUndo = $scope.screenState.recommendMode !== 'ADAPTIVE' ? getLadderDetailsForUndo(getSelectedFiledOrValidatedItems(), $scope.screenState.rawData) : getLadderDetailsForUndoAdaptive(getSelectedFiledOrValidatedItems(), $scope.screenState.rawData);
      if (count === 0) {
        toastr.error($scope.undoToastrError);
        if (getCancelledLadders(getSelectedFiledOrValidatedItems(), $scope.screenState.rawData)) {
          toastr.error('Non system generated Cancelled fare ladders cannot be Undone');
        }
        if (getTargetFaresCancelledLadders(getSelectedFiledOrValidatedItems(), $scope.screenState.rawData)) {
          toastr.error('Undo process not allowed as target fare ladders are discontinued');
        }
      } else {
        $scope.stateChangeModal = $scope.screenState.recommendMode !== 'ADAPTIVE' ? {
          count: count,
          fareRecommendationUndoKeyList: _.chain(ladderDetailsForUndo).map(function (entry) {
            return {
              fareRecommendationRecordKey: entry.ladderId,
              createdAt: entry.createdAt,
              status: entry.status
            };
          }).value()
        } : {
          count: count,
          fareLadderUndoKeyList: _.chain(ladderDetailsForUndo).map(function (entry) {
            return {
              fareLadderRecordKey: entry.ladderId,
              createdAt: entry.createdAt,
              status: entry.status
            };
          }).value()
        };
        $scope.showUndoModal = true;
        $scope.createUndoModal = true;
      }
    }
  };
  $scope.approveAll = function () {
    if (!$scope.disableApproveRejectButtons()) {
      if (FaresOptimizerConstants.CATEGORY.ADAPTIVE === $scope.screenState.recommendMode && featureToggleService.isEnabled('ADAPTIVE_APPROVE_ALL_LADDERS') && $scope.disableApproveButton) {
        return;
      }
      var newOrPendingLadders = getSelectedPendingOrNewItems();
      var count = recommendationEntryService.getApprovalCount(newOrPendingLadders, getApproverLevel(), isOnlyApprover());
      if (count === 0) {
        toastr.error($scope.approveToastrError);
        return;
      }
      var eligibleLadders = getLaddersWithValidFootnotes(newOrPendingLadders);
      count = recommendationEntryService.getApprovalCount(eligibleLadders, getApproverLevel(), isOnlyApprover());
      if (count === 0) {
        toastr.error('Only ladders with valid Footnote dates can be Approved.');
        return;
      }
      eligibleLadders = getLaddersWithValidProducts(eligibleLadders);
      count = recommendationEntryService.getApprovalCount(eligibleLadders, getApproverLevel(), isOnlyApprover());
      if (count === 0) {
        toastr.error('Approval stopped: recommended base fare is same as current or distributed base fare.');
        return;
      }
      var isOTFLadder = isLadderOfOTF();
      var recommendationLadder = recommendationEntryService.getLadderByMaxEffectiveDate(eligibleLadders);
      var maxAllowedApprovalDate = $scope.screenState.recommendMode !== 'ADAPTIVE' || isOTFLadder ? getMaximumAllowedApprovalDate(eligibleLadders) : undefined;
      var sharedFbcsPresent = $scope.screenState.recommendMode !== 'ADAPTIVE' ? hasSharedFbcs(eligibleLadders) : false;
      var ladderDetailsForApproval = $scope.screenState.recommendMode !== 'ADAPTIVE' ? faresOptimizerSharedFbcService.getLadderDetailsForApproval(eligibleLadders, $scope.screenState.rawData) : faresOptimizerSharedFbcService.getAdaptiveLadderDetailsForApproval(eligibleLadders, $scope.screenState.rawData);
      var reverseMarketLadderDetailsForApproval = $scope.screenState.recommendMode === 'ADAPTIVE' && !isOTFLadder ? faresOptimizerSharedFbcService.getAdaptiveLadderDetailsForApproval(getEligibleLaddersForReverseCarrierMarketCabin(eligibleLadders), $scope.screenState.rawData) : [];
      $scope.approveModalData = {
        count: count,
        effectiveDate: recommendationLadder !== undefined ? recommendationLadder.recommendationEffectiveDate : undefined,
        maxAllowedApprovalDate: maxAllowedApprovalDate,
        authorizationNotes: recommendationLadder !== undefined ? recommendationLadder.authorizationNotes : undefined,
        hasSharedFbc: sharedFbcsPresent,
        ladderDetails: ladderDetailsForApproval,
        reverseMarketLadderDetails: reverseMarketLadderDetailsForApproval,
        affectedLadderIdCount: ladderDetailsForApproval.length + reverseMarketLadderDetailsForApproval.length,
        reverseCarrierMarketCabins: getUniqueReverseMarketCabins(reverseMarketLadderDetailsForApproval),
        userNotSelectedRows: getUnselectedLadderDetailsForApproval($scope.userNotSelectedRows),
        allRowsSelected: $scope.allRowsSelected,
        isRecommendationScreen: true,
        recommendMode: $scope.screenState.recommendMode,
        isOTFLadder: isOTFLadder
      };
      var ruleMissingWarningMsg = ruleMissingWarningLadders(newOrPendingLadders);
      var cancelLadderWarningMsg = cancelWarningLadders(newOrPendingLadders);
      if (ruleMissingWarningMsg.length || cancelLadderWarningMsg.length) {
        $scope.warningModalData = $scope.approveModalData;
        $scope.warningModalData.ruleMissingWarningMsg = ruleMissingWarningMsg;
        $scope.warningModalData.cancelLadderWarningMsg = cancelLadderWarningMsg;
        $scope.showWarningModal = true;
        $scope.createWarningModal = true;
      } else {
        $scope.showApproveModal = true;
        $scope.createApproveModal = true;
      }
    }
  };
  function getUnselectedLadderDetailsForApproval(unselectedNewOrPendingLadders) {
    var count = recommendationEntryService.getApprovalCount(unselectedNewOrPendingLadders, getApproverLevel(), isOnlyApprover());
    if (count === 0) {
      return '';
    }
    var unSelectedEligibleLadders = getLaddersWithValidFootnotes(unselectedNewOrPendingLadders);
    count = recommendationEntryService.getApprovalCount(unSelectedEligibleLadders, getApproverLevel(), isOnlyApprover());
    if (count === 0) {
      return '';
    }
    unSelectedEligibleLadders = getLaddersWithValidProducts(unSelectedEligibleLadders);
    count = recommendationEntryService.getApprovalCount(unSelectedEligibleLadders, getApproverLevel(), isOnlyApprover());
    if (count === 0) {
      return '';
    }
    return faresOptimizerSharedFbcService.getLadderDetailsForApproval(unSelectedEligibleLadders, $scope.screenState.rawData);
  }
  function ruleMissingWarningLadders(rows) {
    var ruleMissingMsg = [];
    _.forEach(rows, function (row, index) {
      if (!_.isUndefined(row.ladderRemarks) && !_.isUndefined(row.ladderRemarks.dataComparisonReasons)) {
        var remarks = faresOptimizerDataTransformerService.getDataComparisonReasons(row.ladderRemarks.dataComparisonReasons, false);
        var ruleMissingRemarks = faresOptimizerDataTransformerService.getRuleMissingLadderRemarks(remarks);
        if (ruleMissingRemarks.length) {
          ruleMissingMsg.push('Ladder ' + ++index + ' : ' + ruleMissingRemarks[0] + '\n');
        }
      }
    });
    return ruleMissingMsg;
  }
  function cancelWarningLadders(rows) {
    var cancelLadderMsg = [];
    _.forEach(rows, function (row) {
      if (!_.isUndefined(row.ladderRemarks) && !_.isUndefined(row.ladderRemarks.dataComparisonReasons)) {
        var remarks = faresOptimizerDataTransformerService.getDataComparisonReasons(row.ladderRemarks.dataComparisonReasons, false);
        var cancelLadderRemarks = faresOptimizerDataTransformerService.getCancelLadderRemarks(remarks);
        if (cancelLadderRemarks.length) {
          cancelLadderMsg = cancelLadderRemarks[0];
        }
      }
    });
    return cancelLadderMsg;
  }
  function getMaximumAllowedApprovalDate(eligibleLadders) {
    return _.chain(eligibleLadders).map(getMinimumOfTravelAndReservationDates).filter(filterNotNull).min().value();
  }
  function filterNotNull(date) {
    return date !== undefined;
  }
  function getMinimumOfTravelAndReservationDates(ladder) {
    return recommendationEntryService.getMinimumOfTravelAndReservationDates(ladder);
  }
  function getLaddersWithValidFootnotes(items) {
    return _.filter(items, function (ladder) {
      return recommendationEntryService.isFootnoteDatesValid(ladder);
    });
  }
  function getLaddersWithValidProducts(items) {
    return _.filter(items, function (ladder) {
      return filingFilterService.areThereProductsForFiling(ladder);
    });
  }
  $scope.rejectAll = function () {
    if (!$scope.disableApproveRejectButtons()) {
      var selectedItems = getSelectedItem();
      var count = recommendationEntryService.getRejectionCount(selectedItems.length === 0 ? $scope.getData() : selectedItems, getApproverLevel(), isOnlyApprover());
      var ladderDetailsForRejection = getLadderDetailsForRejection(getItemsForRejection(), $scope.screenState.rawData);
      if (count === 0) {
        toastr.error($scope.rejectToastrError);
      } else {
        $scope.rejectModalData = {
          count: count,
          ladderIds: getLadderIds(getItemsForRejection()),
          entryLevelFbcs: _.chain(ladderDetailsForRejection).map('fbc').value()
        };
        $scope.showRejectModal = true;
        $scope.createRejectModal = true;
      }
    }
  };
  function getLadderDetailsForRejection(data, rawData) {
    var ladderIds = getLadderIds(getItemsForRejection());
    return _.chain(ladderIds).map(function (ladderId) {
      var ladder = $scope.screenState.recommendMode !== 'ADAPTIVE' ? _.find(rawData, {
        'fareRecommendationRecordKey': ladderId
      }) : _.find(rawData, {
        'fareLadderRecordKey': ladderId
      });
      return {
        ladderId: ladderId,
        fbc: ladder.fbc.replace(ladder.fbc.charAt(0), '*')
      };
    }).value();
  }
  function getCancelledLadders(data, rawData) {
    var ladderIds = getLadderIds(data);
    return _.chain(ladderIds).filter(function (ladderId) {
      var ladder = $scope.screenState.recommendMode !== 'ADAPTIVE' ? _.find(rawData, {
        'fareRecommendationRecordKey': ladderId
      }) : _.find(rawData, {
        'fareLadderRecordKey': ladderId
      });
      return ladder.allFaresCancelled;
    }).size() >= 1;
  }
  function getTargetFaresCancelledLadders(data, rawData) {
    var ladderIds = getLadderIds(data);
    return _.chain(ladderIds).filter(function (ladderId) {
      var ladder = $scope.screenState.recommendMode !== 'ADAPTIVE' ? _.find(rawData, {
        'fareRecommendationRecordKey': ladderId
      }) : _.find(rawData, {
        'fareLadderRecordKey': ladderId
      });
      return ladder.areTargetFaresDiscontinued;
    }).size() >= 1;
  }
  function getLadderDetailsForUndo(data, rawData) {
    return _.chain(data).filter(function (entry) {
      var ladder = _.find(rawData, {
        'fareRecommendationRecordKey': entry.fareRecommendationRecordKey,
        'createdAt': entry.createdAt,
        status: entry.status
      });
      return isLadderUndoable(ladder);
    }).map(function (entry) {
      var ladder = _.find(rawData, {
        'fareRecommendationRecordKey': entry.fareRecommendationRecordKey,
        'createdAt': entry.createdAt,
        status: entry.status
      });
      return {
        ladderId: ladder.fareRecommendationRecordKey,
        fbc: ladder.fbc.replace(ladder.fbc.charAt(0), '*'),
        createdAt: ladder.createdAt,
        status: ladder.status
      };
    }).value();
  }
  function getLadderDetailsForUndoAdaptive(data, rawData) {
    return _.chain(data).filter(function (entry) {
      var ladder = _.find(rawData, {
        'fareLadderRecordKey': entry.fareLadderRecordKey,
        'createdAt': entry.createdAt,
        status: entry.status
      });
      return isLadderUndoable(ladder);
    }).map(function (entry) {
      var ladder = _.find(rawData, {
        'fareLadderRecordKey': entry.fareLadderRecordKey,
        'createdAt': entry.createdAt,
        status: entry.status
      });
      return {
        ladderId: ladder.fareLadderRecordKey,
        fbc: ladder.fbc.replace(ladder.fbc.charAt(0), '*'),
        createdAt: ladder.createdAt,
        status: ladder.status
      };
    }).value();
  }
  $scope.approveCallback = function () {
    $scope.screenState.reorderGroupOptions = false;
    var recordKeyList = {
      authorizationNotes: $scope.approveModalData.authorizationNotes,
      fareRecommendationRecordKeyList: _.chain(_.union($scope.approveModalData.ladderDetails, $scope.approveModalData.reverseMarketLadderDetails)).map('ladderId').value() || [],
      effectiveTimeStamp: $scope.approveModalData.effectiveDate.format('YYYY-MM-DDTHH:mm:ss.000ZZ')
    };
    if ($scope.screenState.recommendMode === 'ADAPTIVE') {
      recordKeyList = Object.assign(recordKeyList, {
        fareLadderRecordKeyList: recordKeyList.fareRecommendationRecordKeyList
      });
      delete recordKeyList.fareRecommendationRecordKeyList;
    }
    recommendationEntryDataService.updateRecommendationStatus('approve', recordKeyList, $scope.screenState.displayedRawData, $scope.screenState.rawData, undefined, $scope.screenState.marketRawDataChunks, $scope.screenState.pager.currentPage, $scope.screenState.recommendMode);
  };
  $scope.warningCallback = function (modalData) {
    $scope.screenState.reorderGroupOptions = false;
    $scope.approveModalData = modalData;
    $scope.showApproveModal = true;
    $scope.createApproveModal = true;
  };
  $scope.auditLogCallback = function (modalData) {
    $scope.screenState.reorderGroupOptions = false;
    $scope.auditLogModalData = modalData;
    $scope.showAuditLogModal = true;
    $scope.createAuditLogModal = true;
  };
  $scope.rejectCallback = function () {
    $scope.screenState.reorderGroupOptions = false;
    var recordKeyList = {
      authorizationNotes: $scope.rejectModalData.authorizationNotes,
      rejectionExpiryDateTime: convertToUTC($scope.rejectModalData.rejectionExpiryDateTime),
      fareRecommendationRecordKeyList: $scope.rejectModalData.ladderIds || []
    };
    if ($scope.screenState.recommendMode === 'ADAPTIVE') {
      recordKeyList = Object.assign(recordKeyList, {
        fareLadderRecordKeyList: recordKeyList.fareRecommendationRecordKeyList
      });
      delete recordKeyList.fareRecommendationRecordKeyList;
    }
    recommendationEntryDataService.updateRecommendationStatus('reject', recordKeyList, $scope.screenState.displayedRawData, $scope.screenState.rawData, undefined, $scope.screenState.marketRawDataChunks, $scope.screenState.pager.currentPage, $scope.screenState.recommendMode);
  };
  $scope.rejectionUpdateCallback = function () {
    $scope.screenState.reorderGroupOptions = false;
    var recordKeyList = {
      authorizationNotes: $scope.rejectionPopUpData.authorizationNotes,
      rejectionExpiryDateTime: convertToUTC($scope.rejectionPopUpData.rejectionExpiryDateTime),
      fareRecommendationRecordKeyList: [$scope.rejectionPopUpData.fareRecommendationRecordKey]
    };
    if ($scope.screenState.recommendMode === 'ADAPTIVE') {
      recordKeyList.fareLadderRecordKeyList = [$scope.rejectionPopUpData.fareLadderRecordKey];
      delete recordKeyList.fareRecommendationRecordKeyList;
    }
    recommendationEntryDataService.updateRecommendationStatus('reject', recordKeyList, $scope.screenState.displayedRawData, $scope.screenState.rawData, undefined, $scope.screenState.marketRawDataChunks, $scope.screenState.pager.currentPage, $scope.screenState.recommendMode);
  };
  $scope.updateRecommendationEffDateCallback = function () {
    recommendationEntryDataService.updateRecommendationEffDateAndNotes($scope.screenState.recommendMode !== 'ADAPTIVE' ? {
      authorizationNotes: $scope.statusDetails.updatedData.authorizationNotes,
      fareRecommendationRecordKeyList: getLadderIdsForApprovedLadderUpdation(_.find($scope.screenState.rawData, {
        'fareRecommendationRecordKey': $scope.statusDetails.updatedData.fareRecommendationRecordKey
      })),
      effectiveTimeStamp: $scope.statusDetails.updatedData.recommendationEffectiveDate.format('YYYY-MM-DDTHH:mm:ss.000ZZ')
    } : {
      authorizationNotes: $scope.statusDetails.updatedData.authorizationNotes,
      fareLadderRecordKeyList: getLadderIdsForApprovedLadderUpdation(_.find($scope.screenState.rawData, {
        'fareLadderRecordKey': $scope.statusDetails.updatedData.fareLadderRecordKey
      })),
      effectiveTimeStamp: $scope.statusDetails.updatedData.recommendationEffectiveDate.format('YYYY-MM-DDTHH:mm:ss.000ZZ')
    }, $scope.screenState.displayedRawData, $scope.screenState.rawData, undefined, $scope.screenState.recommendMode);
  };
  $scope.exportToCSV = function () {
    exportToCSVService.exportToCSVFormat([$scope.entry], 'market', $scope.screenState.recommendMode);
  };
  $scope.exportSummaryToCSV = function () {
    exportToCSVService.exportToSummaryCSVFormat([$scope.entry]);
  };
  $scope.$watchCollection('entry.rowGroups', $scope.selectionCallBack);
  function hasSharedFbcs(data) {
    return faresOptimizerSharedFbcService.getSharedEntryLevelFbcs(data, $scope.screenState.rawData).length >= 1;
  }
  function isLadderUndoable(row) {
    return !_.isNil(row) && (row.status === FaresOptimizerConstants.FILED || row.status === FaresOptimizerConstants.VALIDATED) && !row.hasSharedFbc && !row.allFaresCancelled;
  }
  function convertToUTC(localDate) {
    if (localDate) {
      var dateTime = localDate.format('YYYY-MM-DDTHH:mm:ss.000ZZ');
      return momentService.of(dateTime, momentService.getConfig('DATE_TIME'), momentService.getFormat('DATE_TIME_MILLISECONDS_ISO'), undefined, true).value.format('YYYY-MM-DDTHH:mm:ss.000ZZ');
    }
    return undefined;
  }
};
RecommendationEntryController.$inject = ['$scope', 'RecommendationEntryService', 'RecommendationEntryDataService', 'FaresOptimizerCSVExportService', 'FaresOptimizerConstants', 'UserSecureService', 'FaresOptimizerSharedFbcService', 'FaresOptimizerWebFareCurveDataService', 'TacticalFareDefinitionDataService', 'MomentService', 'FaresOptimizerFilingLadderFilterService', 'CityToPosMapper', 'FaresOptimizerDataTransformerService', 'FeatureToggleService', 'FaresOptimizerAnalysisDataService'];
module.exports = RecommendationEntryController;